module.exports = __webpack_public_path__ + "static/media/paella.50f32ef6.jpg";